<template>
  <div id="search-page">
    <!-- page header component -->
    <page-header-component
      icon="bi bi-search"
      title="Search Data"
      :hide-filter="true"
    />
    <!-- page component -->
    <transition name="block">
      <div class="row" v-if="mounted && isSearch">
        <div
          v-if="display_tipe == 2 || display_tipe == 3"
          class="col-12 px-gap"
        >
          <div class="card card-default shade">
            <div class="card-body">
              <div class="form">
                <form action="#" @submit.prevent="searchData">
                  <div class="row align-items-end">
                    <div class="col-md-4 col-sm-12 p-r-10">
                      <label for="">Kata Kunci</label>
                      <input
                        v-model="q"
                        type="text"
                        name=""
                        value=""
                        placeholder="Masukan kata yang akan dicari"
                        class="form-control form-custom rounded"
                        id="kata-kunci-form"
                        required
                        style="border: rgb(230, 222, 222) 0.5px solid"
                      />
                    </div>
                    <div class="col-md-2 col-sm-12 p-r-10">
                      <label for="">Jenis Media</label>
                      <select
                        name="media"
                        id="input-media"
                        v-model="media"
                        class="form-control form-custom rounded"
                        style="border: rgb(230, 222, 222) 0.5px solid"
                      >
                        <option value="all">Semua Media</option>
                        <option value="media_cetak">Media Cetak</option>
                        <option value="media_tv">Media TV</option>
                        <option value="media_online">Online News</option>
                      </select>
                    </div>
                    <div class="col-md-2 col-sm-12 p-r-10">
                      <label for="">Field Pencarian</label>
                      <select
                        name="field_search"
                        id="input-field-search"
                        v-model="search_field"
                        class="form-control form-custom rounded"
                        style="border: rgb(230, 222, 222) 0.5px solid"
                      >
                        <option value="title">Judul Berita</option>
                        <option value="content">Konten Berita</option>
                      </select>
                    </div>
                    <div class="col-md-3 col-sm-12 p-r-10">
                      <label for="">Periode</label>
                      <div
                        id="reportrange"
                        style="
                          background: #fff;
                          cursor: pointer;
                          padding: 5px 10px;
                          width: 100%;
                          height: 35px;
                          border: rgb(230, 222, 222) 0.5px solid;
                        "
                        class="rounded"
                      >
                        <i class="bi bi-calendar-event m-r-15" />&nbsp; <span />
                        <i
                          class="bi bi-caret-down-fill"
                          style="
                            margin-left: 5px !important;
                            color: rgb(155, 156, 156) !important;
                            font-size: 14px !important;
                          "
                        />
                      </div>
                    </div>
                    <div class="col-md-1 col-sm-12">
                      <button class="btn btn-complete btn-lg btn-icon-left">
                        <i class="bi bi-search"></i> <span>Search</span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="display_tipe == 2 || display_tipe == 3"
          class="col-12 px-gap"
        >
          <div class="card card-default shade mt-2">
            <div class="card-body" id="search-result">
              <div
                class="result"
                v-if="!is_loading && !media_online && !media_cetak && !media_tv"
              >
                <i class="bi bi-info-circle text-blue" /> Hasil pencarian akan
                muncul disini.
              </div>
              <loader-component v-else-if="is_loading" />
              <div class="result" v-else>
                <div class="card card-borderless">
                  <ul
                    class="nav nav-tabs nav-tabs-fillup"
                    role="tablist"
                    data-init-reponsive-tabs="dropdownfx"
                  >
                    <li
                      class="nav-item"
                      :class="is_spesific_source ? 'disabled' : ''"
                      v-for="(tab, index) in dataTabs"
                      :key="index"
                      @click="switchTab(tab)"
                    >
                      <a
                        :class="[
                          'tab-button',
                          {
                            active: currentTab.id === tab.id,
                          },
                        ]"
                        data-toggle="tab"
                        role="tab"
                        :data-target="'#tabs-' + index"
                        href="#"
                        @click="currentTab = tab"
                      >
                        <i :class="tab.icon_class" /> {{ tab.name }}
                        <strong
                          v-if="tab.total"
                          style="
                            background: red;
                            height: max-content;
                            width: max-content;
                            padding: 3px;
                            border-radius: 2px;
                          "
                          class="text-white"
                        >
                          {{ tab.total }}
                        </strong>
                      </a>
                    </li>
                  </ul>
                  <div class="tab-content">
                    <!-- online news -->
                    <div v-if="currentTab.name == 'Online News'">
                      <loader-component v-if="is_media_online_loading" />
                      <div v-else>
                        <div v-if="!media_online || media_online.length == 0">
                          <i class="bi bi-info-circle text-blue" /> Data tidak
                          ditemukan
                        </div>
                        <div v-else class="scroller" style="max-height: 30rem">
                          <div
                            v-for="(post, index) in media_online"
                            :key="index"
                            class="card card-default border"
                            style="border-radius: 10px"
                          >
                            <div class="card-header separator">
                              <div class="card-title">
                                <h6 class="no-margin">
                                  <a
                                    href="#"
                                    class="text-primary"
                                    style="opacity: 1"
                                    >{{ post.title }}</a
                                  >
                                </h6>
                              </div>
                              <div class="pull-right">
                                <i class="bi bi-calendar-event" />
                                {{ dateFormatter(post.date) }}
                              </div>
                            </div>
                            <div class="card-body p-t-5">
                              <p>
                                <span title="Sumber">
                                  <i class="bi bi-globe-americas" />
                                  {{ post.account }}
                                </span>
                                <span title="Jurnalis"
                                  ><i class="bi bi-person" />
                                  {{ post.journalist }}</span
                                >
                              </p>
                              <p style="text-align: justify">
                                <span>{{ post.content | write_content }}</span>
                                <a
                                  v-if="isLongText(post.content)"
                                  href="javascript:void(0)"
                                  @click="
                                    showFullContent(index, 'media_online')
                                  "
                                  >Tampilkan selengkapnya</a
                                >
                              </p>
                              <p>
                                <a
                                  :href="post.url || post.file_source"
                                  target="__blank"
                                  class="pull-right hoverable"
                                  style="color: #14a1c8 !important"
                                >
                                  <i class="bi bi-box-arrow-up-right"></i>
                                  Kunjungi</a
                                >
                              </p>
                            </div>
                          </div>
                          <button
                            v-if="media_online.length < total_media_online"
                            class="btn btn-success btn-block"
                            @click="loadMore('media_online')"
                          >
                            <div
                              v-if="is_loadmore_loading"
                              class="spinner-border spinner-border-sm mr-1"
                              role="status"
                            >
                              <span class="sr-only">Loading...</span>
                            </div>
                            <i class="bi bi-arrow-down mt-1 mr-1" v-else></i>
                            Lihat Lebih Banyak
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- media cetak -->
                    <div v-else-if="currentTab.name == 'Media Cetak'">
                      <loader-component v-if="is_media_cetak_loading" />
                      <div v-else>
                        <div v-if="!media_cetak || media_cetak.length == 0">
                          <i class="bi bi-info-circle text-blue" /> Data tidak
                          ditemukan
                        </div>
                        <div class="scroller" style="max-height: 30rem" v-else>
                          <div
                            v-for="(post, index) in media_cetak"
                            :key="index"
                            class="card card-default border"
                            style="border-radius: 10px"
                          >
                            <div class="card-header separator">
                              <div class="card-title">
                                <h6 class="no-margin">
                                  <a
                                    href="#"
                                    class="text-primary"
                                    style="opacity: 1"
                                    >{{ post.title }}</a
                                  >
                                </h6>
                              </div>
                              <div class="pull-right">
                                <i class="bi bi-calendar-event" />
                                {{ dateFormatter(post.date) }}
                              </div>
                            </div>
                            <div class="card-body p-t-5">
                              <p>
                                <span title="Sumber">
                                  <i
                                    class="bi bi-newspaper"
                                    v-if="post.source == 'media_cetak'"
                                  />
                                  {{ post.account }}
                                  Media nya
                                </span>
                                <span title="Jurnalis"
                                  ><i class="bi bi-person" />
                                  {{ post.journalist }}</span
                                >
                              </p>
                              <p style="text-align: justify">
                                <span>{{ post.content | write_content }}</span>
                                <a
                                  v-if="isLongText(post.content)"
                                  href="javascript:void(0)"
                                  @click="showFullContent(index, 'media_cetak')"
                                  >Tampilkan selengkapnya</a
                                >
                              </p>
                              <p>
                                <a
                                  href="#"
                                  @click.prevent="showSumber(post)"
                                  class="pull-right hoverable"
                                  style="color: #28c76f !important"
                                >
                                  <i class="bi bi-eye"></i> Lihat Sumber</a
                                >
                              </p>
                            </div>
                          </div>
                          <button
                            v-if="media_cetak.length < total_media_cetak"
                            class="btn btn-success btn-block"
                            @click="loadMore('media_cetak')"
                          >
                            <div
                              v-if="is_loadmore_loading"
                              class="spinner-border spinner-border-sm mr-1"
                              role="status"
                            >
                              <span class="sr-only">Loading...</span>
                            </div>
                            <i class="bi bi-arrow-down mt-1 mr-1" v-else></i>
                            Lihat Lebih Banyak
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- media tv -->
                    <div v-else-if="currentTab.name == 'Media TV'">
                      <loader-component v-if="is_media_tv_loading" />
                      <div v-else>
                        <div v-if="!media_tv || media_tv.length == 0">
                          <i class="bi bi-info-circle text-blue" /> Data tidak
                          ditemukan
                        </div>
                        <div class="scroller" style="max-height: 30rem" v-else>
                          <div
                            v-for="(post, index) in media_tv"
                            :key="index"
                            class="card card-default border"
                            style="border-radius: 10px"
                          >
                            <div class="card-header separator">
                              <div class="card-title">
                                <h6 class="no-margin">
                                  <a
                                    href="#"
                                    class="text-primary"
                                    style="opacity: 1"
                                  >
                                    {{ post.title }}
                                  </a>
                                </h6>
                              </div>
                              <div class="pull-right">
                                <i class="bi bi-calendar-event" />
                                {{ dateFormatter(post.date) }}
                              </div>
                            </div>
                            <div class="card-body p-t-5">
                              <p>
                                <span title="Sumber">
                                  <i class="bi bi-tv" />
                                  {{ post.account }} - {{ post.program }}
                                </span>
                                <span title="Jurnalis">
                                  <i class="bi bi-person" />
                                  {{ post.journalist }}
                                </span>
                              </p>
                              <p style="text-align: justify">
                                <span>{{ post.content | write_content }}</span>
                                <a
                                  v-if="isLongText(post.content || '-')"
                                  href="javascript:void(0)"
                                  @click="showFullContent(index, 'media_tv')"
                                  >Tampilkan selengkapnya</a
                                >
                              </p>
                              <p>
                                <a
                                  href="#"
                                  @click.prevent="showSumber(post)"
                                  class="pull-right"
                                  style="color: #28c76f !important"
                                >
                                  <i class="bi bi-eye"></i> Lihat Sumber</a
                                >
                              </p>
                            </div>
                          </div>
                          <button
                            v-if="media_tv.length < total_media_tv"
                            class="btn btn-success btn-block"
                            @click="loadMore('media_tv')"
                          >
                            <div
                              v-if="is_loadmore_loading"
                              class="spinner-border spinner-border-sm mr-1"
                              role="status"
                            >
                              <span class="sr-only">Loading...</span>
                            </div>
                            <i class="bi bi-arrow-down mt-1 mr-1" v-else></i>
                            Lihat Lebih Banyak
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="col-12 mt-2 px-gap">
          <div class="card card-default shade">
            <div class="card-body">
              <p>
                Browse data media online seperti TV, Koran, dan lain-lain
                dengan berlangganan data Media Online.
              </p>
              <button class="btn btn-outline-primary" @click="subscribeNow()">
                Langganan Sekarang
              </button>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="row">
        <div class="col-12 mt-1 px-gap">
          <div class="card card-default shade">
            <div class="card-body" id="search-result">
              <div class="result">
                <i class="bi bi-info-circle text-blue"></i> Fitur ini tidak lagi
                tersedia.
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- modal sumber component -->
    <modal-dynamic-component
      v-if="show_modal_sumber"
      :key="modal_sumber_key"
      modal_id="modal_sumber"
      :modal="modal_sumber"
      :data="modal_sumber_data"
      @close="closeModal"
    />
    <!-- tour component -->
    <v-tour
      v-if="tour_steps.length > 0"
      name="myTour"
      :steps="tour_steps"
      :options="{ highlight: true }"
    />
  </div>
</template>

<script>
import $ from "jquery";
import moment from "moment";
import "bootstrap-daterangepicker/daterangepicker.js";
import swal from "sweetalert";
import page_header from "@/views/components/page_header.vue";
import loader from "@/views/components/loader.vue";
import modal_dynamic from "@/views/components/modal_dynamic.vue";
import modal_sumber_body from "@/views/components/mention/modal_sumber.vue";
import gp from "@/plugins/generalPlugins.js";

export default {
  name: "Search",
  title: "Search | Sibernetik",
  components: {
    "page-header-component": page_header,
    "loader-component": loader,
    "modal-dynamic-component": modal_dynamic,
  },
  data() {
    return {
      dataTabs: [
        {
          id: "media_online",
          name: "Online News",
          icon_class: "bi bi-globe-americas",
          total: 0,
        },
        {
          id: "media_cetak",
          name: "Media Cetak",
          icon_class: "bi bi-newspaper",
          total: 0,
        },
        {
          id: "media_tv",
          name: "Media TV",
          icon_class: "bi bi-tv",
          total: 0,
        },
      ],
      currentTab: {
        id: "media_online",
        name: "Online News",
        icon_class: "bi bi-globe-americas",
        total: 0,
      },
      is_spesific_source: false,
      tab_key: 0,
      id_project: this.$store.getters.user.id_project,
      is_loading: false,
      is_media_online_loading: false,
      is_media_cetak_loading: false,
      is_media_tv_loading: false,
      result: null,
      media_online: null,
      media_cetak: null,
      media_tv: null,
      total_media_online: 0,
      total_media_cetak: 0,
      total_media_tv: 0,
      mounted: false,
      periode: null,
      start: "",
      end: "",
      media: "all",
      q: "q" in this.$route.query ? this.$route.query.q : "",
      result_for: "",
      page: 1,
      page_media_online: 1,
      page_media_cetak: 1,
      page_media_tv: 1,
      token: "Token 786858e917b25147e7c647fc17b0c38d7b2610ed",
      api: "https://api.digivla.id/api/v1/search/",
      totalItems: 0,
      data_paging: null,
      search_field: "title",
      modal_sumber: null,
      modal_sumber_key: 0,
      modal_sumber_data: [],
      modal_sumber_body: modal_sumber_body,
      show_modal_sumber: false,
      tour_steps: [],
      display_tipe:
        this.$store.getters.user.project.project_detail.display_tipe,
      isSearch:
        "features" in this.$store.getters.user.project.project_detail
          ? this.$store.getters.user.project.project_detail.features.search
            ? 1
            : 0
          : 0,
      is_loadmore_loading: false,
    };
  },
  methods: {
    switchTab: function (tab) {
      this.currentTab = tab;
      if (this.currentTab.data && !("no_refresh" in this.currentTab)) {
        this.tab_key++;
      }
    },
    loadMore: function (type) {
      if (type == "media_online") {
        this.page_media_online++;
      } else if (type == "media_cetak") {
        this.page_media_cetak++;
      } else {
        this.page_media_tv++;
      }
      this.getData(type, true);
    },
    loadFilter: function () {
      if ("from" in this.$route.query) {
        this.start = moment(this.$route.query.from);
      } else {
        this.start = moment().subtract(6, "days");
      }

      if ("to" in this.$route.query) {
        this.end = moment(this.$route.query.to);
      } else {
        this.end = moment(); // Today
      }

      var dateRange = {};
      dateRange["Hari ini"] = [moment().format("D MMM YYYY"), moment()];
      dateRange["Kemarin"] = [
        moment().subtract(1, "days").format("D MMM YYYY"),
        moment().subtract(1, "days").format("D MMM YYYY"),
      ];
      dateRange["7 Hari Terakhir"] = [
        moment().subtract(6, "days"),
        moment().format("D MMM YYYY"),
      ];
      dateRange["1 Bulan Terakhir"] = [
        moment().subtract(29, "days").format("D MMM YYYY"),
        moment(),
      ];
      dateRange["3 Bulan Terakhir"] = [
        moment()
          .subtract(30 * 3 - 1, "days")
          .format("D MMM YYYY"),
        moment(),
      ];

      $("#search-wrapper #reportrange").daterangepicker(
        {
          timePicker: false,
          timePicker24Hour: false,
          showDropdowns: true,
          startDate: this.start,
          maxDate: this.end,
          endDate: this.end,
          ranges: dateRange,
          opens: "center",
          locale: {
            format: "DD MMM YYYY",
            applyLabel: "Cari",
            cancelLabel: "Batal",
            monthNames: [
              "Januari",
              "Februari",
              "Maret",
              "April",
              "Mei",
              "Juni",
              "Juli",
              "Agustus",
              "September",
              "Oktober",
              "November",
              "Desember",
            ],
          },
        },
        this.changeDate
      );
      this.changeDate(this.start, this.end, "default");
    },
    changeDate: function (start, end, def_value) {
      let from;
      let to;

      if (def_value != "Custom Range") {
        from = start.locale("id").format("YYYY-MM-DD");
        to = end.locale("id").format("YYYY-MM-DD");
        $("#reportrange span").html(
          start.format("D MMM YYYY") + " - " + end.format("D MMM YYYY")
        );
      } else {
        from = start.locale("id").format("YYYY-MM-DD");
        to = end.locale("id").format("YYYY-MM-DD");
        $("#reportrange span").html(
          start.format("D MMM YYYY") + " - " + end.format("D MMM YYYY")
        );
      }
      this.start = from;
      this.end = to;
    },
    searchData: function () {
      this.is_loading = true;
      this.page = 1;
      this.page_media_online = 1;
      this.page_media_cetak = 1;
      this.page_media_tv = 1;
      if (this.media == "all") {
        this.getData("media_online");
      } else {
        this.getData(this.media);
      }
    },
    getData: function (type, is_loadmore = false) {
      let param = {
        end_date: this.end,
        maxSize: 10,
        media_category: is_loadmore ? type : this.media,
        page:
          type == "media_online"
            ? this.page_media_online
            : type == "media_cetak"
            ? this.page_media_cetak
            : type == "media_tv"
            ? this.page_media_tv
            : this.page,
        search_field: this.search_field,
        start_date: this.start,
        term: this.q,
      };
      if (this.media == "all") {
        this.is_spesific_source = false;
      } else {
        this.is_spesific_source = true;
      }
      if (is_loadmore) {
        this.is_loadmore_loading = true;
        if (type == "media_online") {
          this.currentTab = this.dataTabs[0];
          this.is_media_online_loading = false;
        } else if (type == "media_cetak") {
          this.currentTab = this.dataTabs[1];
          this.is_media_cetak_loading = false;
        } else if (type == "media_tv") {
          this.currentTab = this.dataTabs[2];
          this.is_media_tv_loading = false;
        }
      } else {
        if (type == "media_online") {
          this.currentTab = this.dataTabs[0];
          this.is_media_online_loading = true;
        } else if (type == "media_cetak") {
          this.currentTab = this.dataTabs[1];
          this.is_media_cetak_loading = true;
        } else if (type == "media_tv") {
          this.currentTab = this.dataTabs[2];
          this.is_media_tv_loading = true;
        }
      }

      let api = "https://be.kurasi.media/search-global-be/search";
      this.$http
        .post(api, { data: param })
        .then((response) => {
          if (response.status == 200) {
            if (is_loadmore) {
              if (type == "media_online") {
                response.data.media_online.streams.forEach((el) => {
                  this.media_online.push(el);
                });
              } else if (type == "media_cetak") {
                response.data.media_cetak.streams.forEach((el) => {
                  this.media_cetak.push(el);
                });
              } else if (type == "media_tv") {
                response.data.media_tv.streams.forEach((el) => {
                  this.media_tv.push(el);
                });
              }
            } else {
              this.media_online = response.data.media_online.streams;
              this.total_media_online =
                response.data.media_online.page_info.total;
              this.media_cetak = response.data.media_cetak.streams;
              this.total_media_cetak =
                response.data.media_cetak.page_info.total;
              this.media_tv = response.data.media_tv.streams;
              this.total_media_tv = response.data.media_tv.page_info.total;
            }
            this.dataTabs[0].total = this.total_media_online;
            this.dataTabs[1].total = this.total_media_cetak;
            this.dataTabs[2].total = this.total_media_tv;
            this.result_for = this.q;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.is_loading = false;
          this.is_media_online_loading = false;
          this.is_media_cetak_loading = false;
          this.is_media_tv_loading = false;
          this.is_loadmore_loading = false;
        });
    },
    showFullContent: function (index, type) {
      let content_el = $(event.target).parent().children().first();
      let content = $(event.target).parent().children().first().html();
      if (content.length <= 400) {
        if (type == "media_online") {
          content_el.html(this.media_online[index].content);
        } else if (type == "media_cetak") {
          content_el.html(this.media_cetak[index].content);
        } else if (type == "media_tv") {
          content_el.html(this.media_tv[index].content);
        }

        $(event.target).html("Sembunyikan");
      } else {
        if (type == "media_online") {
          content_el.html(this.media_online[index].content.substring(0, 400));
        } else if (type == "media_cetak") {
          content_el.html(this.media_cetak[index].content.substring(0, 400));
        } else if (type == "media_tv") {
          content_el.html(this.media_tv[index].content.substring(0, 400));
        }

        $(event.target).html("Tampilkan selengkapnya");
      }
    },
    isLongText(content) {
      if (content.length < 400) {
        return false;
      } else {
        return true;
      }
    },
    showSumber: function (posts) {
      if (posts.source) {
        let post = {
          source: posts.source,
          file_source: posts.file_source,
          data_source: "dgv",
        };
        this.modal_sumber = {
          title: "Sumber Data",
          subtitle: "",
          component: this.modal_sumber_body,
        };
        this.modal_sumber_data = [post];
        this.modal_sumber_key++;
        this.show_modal_sumber = true;
      } else {
        swal({
          title: "File tidak ditemukan!",
          text: "File sumber tidak ditemukan. Beberapa berita mungkin saja tidak disertai dengan file sumber.",
          icon: "info",
          buttons: "Tutup",
          dangerMode: false,
        });
      }
    },
    closeModal: function () {
      this.show_modal_sumber = false;
    },
    dateFormatter: function (date) {
      return gp.convertDate(date);
    },
    subscribeNow: function () {
      let phone = process.env.VUE_APP_WA_CONTACT;
      let media;
      if (this.display_tipe == 1) {
        media = "Media Konvensional";
      } else {
        media = "Media Sosial";
      }
      let project = this.$store.getters.user.project.project_detail.name;

      let message =
        "Saya ingin berlangganan data " +
        media +
        " untuk project " +
        project +
        ". Terima kasih.";
      let href =
        "https://api.whatsapp.com/send?phone=" + phone + "&text=" + message;
      window.open(href);
    },
  },
  filters: {
    write_content: function (content) {
      if (content) {
        if (content.length < 400) {
          return content;
        } else {
          return content.substring(0, 350);
        }
      } else {
        return "-";
      }
    },
  },
  mounted: function () {
    this.mounted = true;
    let self = this;
    $(function () {
      self.loadFilter();
    });

    let v_step = [];
    v_step[0] = {
      target: "#kata-kunci-form",
      header: {
        title: "Kata Kunci",
      },
      content: "Masukan kata kunci yang akan dicari pada kotak inputan ini.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[1] = {
      target: "#input-media",
      header: {
        title: "Jenis Media",
      },
      content: "Pilih jenis media dari kata kunci yang akan dicari.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[2] = {
      target: "#input-field-search",
      header: {
        title: "Field Pencarian",
      },
      content:
        "Pilih field pencarian dari kata kunci, Anda dapat memilih mencari kata kunci pada judul berita atau konten berita.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[3] = {
      target: "#reportrange",
      header: {
        title: "Periode Pencarian",
      },
      content: "Pilih periode pencarian data.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[4] = {
      target: "#search-result",
      header: {
        title: "Hasil Pencarian",
      },
      content: "Hasil pencarian Anda akan muncul disini.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    this.tour_steps = v_step;
  },
};
</script>

<style scoped>
input,
select {
  padding-left: 10px !important;
}
select,
select option {
  cursor: pointer;
}

#start-date {
  border: none !important;
}
.nav-tabs-fillup > li > a:after {
  background-color: #00a46c !important;
}
.disabled {
  pointer-events: none;
  cursor: not-allowed;
}
</style>
